module.exports = __webpack_public_path__ + "media/metronic/_theme/media/files/doc-c72dfa7018d295305acc5ec4666fc940.svg";